<template>
  <div
    class="d-flex flex-column ga-2 min-w-0"
    :class="{ 'align-center text-center': isMobile }"
  >
    <div
      class="min-w-0"
      :class="isMobile
        ? 'text-subtitle-1 font-weight-medium'
        : 'text-h5 font-weight-medium text-no-wrap'"
    >
      <a
        class="primary--text text-decoration-none"
        :class="{ 'text-wrap': !isMobile }"
        :href="doctorPageUrl"
      >{{ doctorName }}</a>&nbsp;<DoctorCardActions
        v-if="!isMobile"
        class="ml-1"
        :doctor-id="doctor.id"
        :doctor-page-url="doctorPageUrl"
        :size="24"
      />
    </div>

    <div
      v-if="specialityText"
      class="text-secondary--text"
      :class="isMobile ? 'text-body-2' : 'text-body-1'"
    >
      {{ specialityText }}
    </div>

    <AwardWinner
      v-if="doctor.is_award_or_grand_prix_winner"
      type="doctor"
      :redirect-url="`${doctorPageUrl}#medals`"
      :current-award-year="currentAwardYear"
      :is-award-or-grand-prix-winner="Boolean(doctor.is_award_or_grand_prix_winner)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import useContextStore from 'src/store/useContextStore'
import type { CommonContextStore } from 'src/types/context'
import AwardWinner from 'src/components/common/AwardWinner/AwardWinner.vue'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import filterFirstLowerCaseForSpeciality from 'common/filters/filterFirstLowerCaseForSpeciality'
import getDoctorNameField from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/functions/getDoctorNameField'
import DoctorCardActions from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardActions.vue'
import type { LpuDoctor } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

const props = defineProps<{
  doctor: LpuDoctor
  doctorPageUrl: string
}>()

const isMobile = useIsMobile()
const { context }: CommonContextStore = useContextStore()
const currentAwardYear = computed(() => context.site_settings?.current_award_year || 0)
const doctorName = computed(() => tDynamic(props.doctor, getDoctorNameField(props.doctor)))
const specialityText = computed(() => {
  const workplace = props.doctor.workplace_info
  const fromStr = workplace ? tDynamic(workplace, 'speciality_str') : ''

  if (fromStr) {
    return fromStr
  }

  return (workplace?.specialities || []).map((speciality, index) => {
    const name = tDynamic(speciality, 'name')

    return index === 0 ? name : filterFirstLowerCaseForSpeciality(name)
  }).join(', ')
})
</script>
